export default function getSetupFeeAmount(setupFee, quantity, setupFeeMultipliesWithQuantity) {
  if (!setupFee) return 0;

  let amount = Number(setupFee);

  if (setupFeeMultipliesWithQuantity) {
    amount = amount * quantity;
  }

  return amount;
}
